import React, { useMemo } from "react";
import { PeekDivider, PeekStack } from "@piiqtechnologies/ui-components";
import { useIntl } from "react-intl";
import messages from "../messages.i18n";
import AmenitySelector from "@components/common/amenity-selector";
export const SpaceAmenities = ({ form, field, label }) => {
    const intl = useIntl();
    const defaultAmenitiesList = useMemo(() => [
        intl.formatMessage(messages.amenitiesAirConditioning),
        intl.formatMessage(messages.amenitiesBalcony),
        intl.formatMessage(messages.amenitiesDishwasher),
        intl.formatMessage(messages.amenitiesFurnished),
        intl.formatMessage(messages.amenitiesParking),
        intl.formatMessage(messages.amenitiesOutdoor),
        intl.formatMessage(messages.amenitiesStorage),
    ], []);
    const amenities = field.value;
    const handleAmenitiesChange = (amenities) => {
        //@ts-ignore
        form.setFieldValue(field.name, amenities);
    };
    return (React.createElement(PeekStack, { direction: "column", spacing: 3 },
        React.createElement(PeekDivider, { light: true, sx: { mt: 3 } }),
        React.createElement(AmenitySelector, { defaultAmenities: defaultAmenitiesList, value: amenities, onChange: handleAmenitiesChange, label: label, noOfColumns: 3 })));
};
export default SpaceAmenities;
